import { render, staticRenderFns } from "./AdminConfirmDialog.vue?vue&type=template&id=c6f5bb3a&"
import script from "./AdminConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./AdminConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports